if (!customElements.get('video-loader')) {
  customElements.define('video-loader', class VideoLoader extends HTMLElement {
    constructor() {
      super();
      this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), {
        root: null, // Use the viewport as the root
        threshold: 0.5, // Trigger when 50% of the element is visible
      });

    }

    connectedCallback() {
      this.observeVideos();
      this.playButtons();
      this.listenVideoPause();
      this.listenVideoPlay();
    }

    // play closest video when play button is clicked
    playButtons() {
      const buttons = this.querySelectorAll('.video-play-button');
      if (!buttons) return;
      buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          const video = button.closest('.video-section__media').querySelector('video');
          video.play();
          button.style.display = 'none';
        });
      });
    }

    // listen when videos get paused, then show play buttons back
    listenVideoPause() {
      const videos = this.querySelectorAll('video');
      if (!videos) return;
      videos.forEach((video) => {
        video.addEventListener('pause', (event) => {
          const buttons = this.querySelectorAll('.video-play-button');
          if (!buttons) return;
          buttons.forEach((button) => {
            button.style.display = 'block';
          });
        });
      });
    }

    listenVideoPlay() {
      const videos = this.querySelectorAll('video');
      if (!videos) return;
      videos.forEach((video) => {
        video.addEventListener('play', (event) => {
          const buttons = this.querySelectorAll('.video-play-button');
          if (!buttons) return;
          buttons.forEach((button) => {
            button.style.display = 'none';
          });
        });
      });
    }

    // Define a function to observe videos within the custom element and load them when they become visible
    observeVideos() {
      const videos = this.querySelectorAll('video');

      videos.forEach((video) => {
        this.intersectionObserver.observe(video);

        video.setAttribute('data-paused', 'false')

        video.addEventListener('pause', (event) => {
          video.setAttribute('data-paused', 'true')
        });

      });
    }

    // Handle the intersection changes (when videos become visible/invisible)
    handleIntersection(entries, observer) {
      entries.forEach((entry) => {

        const video = entry.target;

        if (entry.isIntersecting) {

          const sources = video.querySelectorAll("source[data-src]");

          sources.forEach((source) => {
            source.src = source.getAttribute("data-src");
          });


          if(video.getAttribute('data-paused') == 'false'){
            video.load();
          }else{
            if(entry.target.getAttribute("autoplay") === 'autoplay'){
              video.setAttribute('data-paused', 'false')
              video.play();
            }
          }

          video.onloadeddata = function() {
            if(entry.target.getAttribute("autoplay") === 'autoplay'){
              video.setAttribute('data-paused', 'false')
              video.play();
            }
          }
          // Unobserve the video once it's loaded
          // observer.unobserve(video);
        }else{
          video.pause();
        }
      });
    }

    // Clean up the Intersection Observer when the element is removed from the DOM
    disconnectedCallback() {
      this.intersectionObserver.disconnect();
    }
  });
}
